import { baseStoreCreator } from '@/utils/store';

export interface EditDeductibleModalStorePayload {
  visible: boolean;
}

export const DEFAULT_VALUES: EditDeductibleModalStorePayload = {
  visible: false,
};

export const useEditDeductibleModalStore = baseStoreCreator<EditDeductibleModalStorePayload>(DEFAULT_VALUES);

export default useEditDeductibleModalStore;
